
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 10.875c.66 0 1.22-.23 1.682-.693a2.29 2.29 0 00.693-1.682c0-.66-.23-1.22-.693-1.682A2.29 2.29 0 008.5 6.125c-.66 0-1.22.231-1.682.693A2.29 2.29 0 006.125 8.5c0 .66.23 1.22.693 1.682a2.29 2.29 0 001.682.693zm0 5.542a7.71 7.71 0 01-3.087-.624 7.994 7.994 0 01-2.514-1.692 7.995 7.995 0 01-1.692-2.513A7.71 7.71 0 01.583 8.5c0-1.095.208-2.124.624-3.087a7.995 7.995 0 011.692-2.514 7.995 7.995 0 012.514-1.692A7.709 7.709 0 018.5.583c1.095 0 2.124.208 3.088.624.963.416 1.8.98 2.513 1.692a7.994 7.994 0 011.692 2.514c.416.963.624 1.992.624 3.087a7.708 7.708 0 01-.624 3.088 7.994 7.994 0 01-1.692 2.513 7.995 7.995 0 01-2.514 1.692 7.71 7.71 0 01-3.087.624z"}})])
          )
        }
      }
    